export default __webpack_public_path__ + "static/media/cap60-weatherization.010f1d51.jpeg";